import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../Components/layouts";
import { notify } from '../../utils';
import { REQUIRED_ERROR } from '../../utils/constants';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { UserServices } from '../../Services/UserServices';
import { CustomerServices } from '../../Services/CustomerServices';
import userDefaultImage from '../../Assets/images/user-default-image.png';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { TextField } from '@material-ui/core';
import { useHistory } from 'react-router';
import SendTestEmailModal from 'Components/SendTestEmailModal';
import commonStyles from 'theme/commonStyles';
import variables from '../../Sys/variable.scss';

const userServices = new UserServices();
const customerServices = new CustomerServices();

const useStyles = makeStyles((theme) => ({
    inputStyle: {
        borderColor: 'rgba(0, 0, 0, 0.12)',
        borderRadius: '8px',
        padding: '12px 16px',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        transition: 'all 0.2s ease',
        fontSize: '0.9375rem',
        '&:hover': {
            borderColor: 'rgba(0, 0, 0, 0.2)',
        },
        '&:focus': {
            borderColor: theme.palette.primary.main,
            boxShadow: '0 0 0 3px rgba(60, 125, 221, 0.1)',
        },
    },
    pageHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '25px 0',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: theme.spacing(2),
        },
    },
    heading: {
        color: variables.labelcolor,
        fontSize: '28px',
        fontWeight: '600',
        letterSpacing: '-0.02em',
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            marginBottom: theme.spacing(2),
        },
    },
    btn: {
        padding: '12px 32px',
        fontSize: '14px',
        fontWeight: '500',
        color: 'white',
        borderRadius: '8px',
        marginLeft: '12px',
        textTransform: 'none',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 8px rgba(60, 125, 221, 0.2)',
        '&:hover': {
            boxShadow: '0 4px 12px rgba(60, 125, 221, 0.3)',
            transform: 'translateY(-1px)',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            marginTop: theme.spacing(1),
            width: '100%',
            padding: '12px 24px',
        },
    },
    cancelBtn: {
        padding: '12px 32px',
        background: '#B7B7B7',
        fontSize: '14px',
        fontWeight: '500',
        color: 'white',
        borderRadius: '8px',
        marginLeft: '12px',
        textTransform: 'none',
        transition: 'all 0.2s ease',
        "&:hover": {
            background: "#454343",
            transform: 'translateY(-1px)',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            width: '100%',
            padding: '12px 24px',
        },
    },
    placeBtn: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(2),
        padding: theme.spacing(3, 0),
        marginTop: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column-reverse',
            gap: theme.spacing(1.5),
            padding: theme.spacing(2, 0),
        },
    },
    imgIcon: {
        width: 140,
        height: 140,
        borderRadius: '50%',
        objectFit: 'cover',
        border: '4px solid rgba(0, 0, 0, 0.08)',
        transition: 'all 0.2s ease',
        [theme.breakpoints.down('sm')]: {
            width: 120,
            height: 120,
        },
    },
    input: {
        display: 'none'
    },
    icon: {
        position: 'relative',
        borderRadius: '50%',
        textAlign: 'center',
        display: 'inline-block',
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
        },
    },
    iconStyle: {
        borderRadius: '50%',
        color: '#000',
        background: '#fff',
        border: '2px solid rgba(0, 0, 0, 0.12)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.2s ease',
        '&:hover': {
            background: '#f5f5f5',
            borderColor: 'rgba(0, 0, 0, 0.2)',
            transform: 'scale(1.05)',
        },
    },
    iconbtn: {
        bottom: '0',
        right: '0',
        position: 'absolute',
        [theme.breakpoints.down('sm')]: {
            bottom: '5px',
            right: '5px',
        },
    },
    profileImageContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            marginBottom: theme.spacing(3),
        },
    },
    fieldLabel: {
        '& .MuiFormLabel-root': {
            color: variables.labelcolor,
        },
    },
    smtpSection: {
        marginTop: theme.spacing(3),
        padding: theme.spacing(3),
        background: 'rgba(0, 0, 0, 0.02)',
        borderRadius: '12px',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
    },
    smtpTitle: {
        textAlign: 'center',
        marginBottom: theme.spacing(3),
        fontSize: '20px',
        fontWeight: '600',
        color: variables.labelcolor,
        [theme.breakpoints.down('sm')]: {
            fontSize: '18px',
            marginBottom: theme.spacing(2),
        },
    },
    editThemeBtn: {
        marginLeft: 0,
        marginTop: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
}));

const initFormState = {
    firstName: '',
    lastName: '',
    country: '',
    email: '',
    memberSince: '',
    profile_image: '',
    email_host: '',
    port: '22',
    from: '',
    email_host_user: '',
    email_host_password: '',
    email_subject_prifix: '',
    recipients: ''
};

const Profile = () => {

    const classes = useStyles();
    const commonClasses = commonStyles();

    const history = useHistory();
    const [companyName, setCompanyName] = useState('');
    const [countryList, setCountryList] = useState([]);
    const [countryName, setCountryName] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showSMTP, setShowSMTP] = useState(false);
    const [formState, setFormState] = useState({ ...initFormState });
    const [partner, setPartner] = useState(false);
    const [sendTestMailOpen, setSendTestMailOpen] = useState(false);
    const [sendTestEmailLoading, setSendTestEmailLoading] = useState(false);


    useEffect(() => {
        getUserProfile();
    }, []);

    async function getUserProfile() {
        const user = await userServices.getDetailMyProfile();
        if (user && user.data && user.data.length) {
            const userData = user.data[0];
            setCountryName(userData.country);
            setFormState({
                firstName: userData.firstName,
                lastName: userData.lastName,
                email: userData.email,
                member_since: userData.member_since,
                profile_image: userData.profile_image,
                country: userData.country,
                email_host: userData.email_host,
                email_host_password: userData.email_host_password,
                email_host_user: userData.email_host_user,
                email_subject_prifix: userData.email_subject_prifix,
                smtp: userData.smtp,
                strategy_partner: userData.strategy_partner,
                port: "22",
                secure_connection: false,
                use_authentication: false
            });
            setPartner(userData.strategy_partner)
            if (userData.smtp) {
                setShowSMTP(true);
            }
            const customer = user.data[0].customers && user.data[0].customers[0] ? user.data[0].customers[0].company_name : '';
            setCompanyName(customer);
        }
        const countryList = await customerServices.getCounties();
        setCountryList(countryList?.country_list || []);
    }

    const handleInputChange = (evt) => {
        const { name, value } = evt.target;
        setFormState({ ...formState, [name]: value });
    }

    const formValidationCheck = () => {
        if (!formState.firstName || !formState.lastName || !formState.email || !formState.country) {
            notify("error", REQUIRED_ERROR);
            return null;
        }
        return handleFormSubmit(formState);
    }

    const handleFormSubmit = async (formState) => {
        setLoading(true)
        let result = await userServices.updateProfile(formState)
        if (result && result.status) {
            setLoading(false);
            notify("success", result.message);
            history.push('/dashboard');
        } else {
            notify("error", result && result.message ? result.message : 'Something Went Wrong')
            setLoading(false)
        }
    }

    const handleUploadImage = (e) => {
        let file = e.target.files[0];
        if (!file) return;
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            setFormState({ ...formState, profile_image: reader.result })
        };
    }

    const handleChange = (value, field) => {
        setCountryName(value)
        setFormState({ ...formState, [field]: value });
    }

    const handleChangeCheck = () => {
        setShowSMTP(!showSMTP)
    }

    const handleChangeCheckItem = (name) => {
        if (name === "secure_connection") {
            setFormState({ ...formState, secure_connection: !formState.secure_connection })
        } else {
            setFormState({ ...formState, use_authentication: !formState.use_authentication })
        }
    }

    const editTheme = () => {
        const compId = localStorage.getItem('company_id');
        history.push(`/themeeditor/customer/${compId}`);
    }

    const handleSendEmailSubmit = async (recipients) => {
        setSendTestEmailLoading(true);
        let sendEmailData = { ...formState };

        let data = {
            email_host: sendEmailData.email_host,
            email_subject_prifix: sendEmailData.email_subject_prifix,
            email_host_user: sendEmailData.email_host_user,
            email_host_password: sendEmailData.email_host_password,
            recipients: recipients
        };
        const emailRes = await customerServices.sendTestEmail(data);
        if (emailRes && emailRes.status) {
            notify('success', emailRes?.message || "Email send successfully");
        } else {
            notify("error", (emailRes && emailRes.message) ? emailRes.message : 'Something Went Wrong');
        }
        setSendTestEmailLoading(false);
    }

    return (
        <Layout>
            <main>
                <div className={commonClasses.contentWrapper}>
                    <Typography
                        variant="h1"
                        className={classes.heading}
                        color="textPrimary">
                        Profile
                    </Typography>
                    <div className={classes.profileImageContainer}>
                        <div className={classes.icon}>
                            <img
                                className={classes.imgIcon}
                                src={formState.profile_image ? formState.profile_image : userDefaultImage} alt='User Image' />
                            <div className={classes.iconbtn}>
                                <input accept="image/*" className={classes.input} onChange={handleUploadImage} id="icon-button-file" type="file" />
                                <label htmlFor="icon-button-file">
                                    <IconButton
                                        className={classes.iconStyle}
                                        color="primary"
                                        aria-label="upload picture"
                                        component="span">
                                        <CameraAltOutlinedIcon />
                                    </IconButton>
                                </label>
                            </div>
                        </div>
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="First Name"
                                value={formState.firstName}
                                type="text"
                                name="firstName"
                                // placeholder="First Name"
                                // color="secondary"
                                onChange={handleInputChange}
                                variant="outlined"
                            // InputProps={{ disableUnderline: true, className: classes.inputStyle }}
                            // className={classes.fieldLabel}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="Last Name"
                                value={formState.lastName}
                                type="text"
                                name="lastName"
                                // placeholder="Last Name"
                                // color="secondary"
                                onChange={handleInputChange}
                                variant="outlined"
                            // InputProps={{ disableUnderline: true, className: classes.inputStyle }}
                            // className={classes.fieldLabel}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="Member Since"
                                value={formState.member_since}
                                type="text"
                                name="member_since"
                                // placeholder="Member Since"
                                // color="secondary"
                                onChange={handleInputChange}
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                            // InputProps={{ disableUnderline: true, className: classes.inputStyle }}
                            // className={classes.fieldLabel}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="Email"
                                value={formState.email}
                                type="text"
                                disabled
                                name="email"
                                // placeholder="Email"
                                // color="secondary"
                                onChange={handleInputChange}
                                variant="outlined"
                            // InputProps={{
                            //     disableUnderline: true,
                            //     className: classes.inputStyle,
                            //     style: { opacity: 0.7 },
                            // }}
                            // className={classes.fieldLabel}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="Company Name"
                                value={companyName}
                                type="text"
                                disabled
                                name="customer"
                                // placeholder="Company Name"
                                // color="secondary"
                                variant="outlined"
                            // InputProps={{
                            //     disableUnderline: true,
                            //     className: classes.inputStyle,
                            //     style: { opacity: 0.7 },
                            // }}
                            // className={classes.fieldLabel}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Autocomplete
                                id="combo-box-demo4"
                                value={formState.country}
                                options={countryList ? countryList : []}
                                getOptionLabel={option => option}
                                onChange={(event, newValue) => {
                                    handleChange(newValue, 'country');
                                }}
                                // style={{ width: "100%" }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Country"
                                        variant="outlined"
                                        color="secondary"
                                    // placeholder="Select Country"
                                    // InputProps={{
                                    //     ...params.InputProps,
                                    //     disableUnderline: true,
                                    //     className: classes.inputStyle,
                                    // }}
                                    // inputProps={{
                                    //     ...params.inputProps,
                                    //     style: { width: '100%' },
                                    // }}
                                    // className={classes.fieldLabel}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    {partner && (<React.Fragment>
                        <Grid container spacing={3} style={{ marginTop: 16 }}>
                            <Grid item xs={12}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={<Checkbox checked={showSMTP ? true : false} onChange={() => handleChangeCheck('smtp')} name="smtp" />}
                                        label="SMTP Settings"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                        {showSMTP && (
                            <div className={classes.smtpSection}>
                                <Typography variant='h4' className={classes.smtpTitle}>
                                    SMTP Details
                                </Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="SMTP Server"
                                            value={formState.email_host}
                                            type="text"
                                            name="email_host"
                                            // placeholder="SMTP Server"
                                            // color="secondary"
                                            onChange={handleInputChange}
                                            variant="outlined"
                                        // InputProps={{ disableUnderline: true, className: classes.inputStyle }}
                                        // className={classes.fieldLabel}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Port"
                                            value={formState.port}
                                            type="text"
                                            name="smtp"
                                            // placeholder="Port"
                                            // color="secondary"
                                            onChange={handleInputChange}
                                            variant="outlined"
                                        // InputProps={{ disableUnderline: true, className: classes.inputStyle }}
                                        // className={classes.fieldLabel}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Email Account"
                                            value={formState.from}
                                            type="text"
                                            name="from"
                                            // placeholder="Email Account"
                                            // color="secondary"
                                            onChange={handleInputChange}
                                            variant="outlined"
                                        // InputProps={{ disableUnderline: true, className: classes.inputStyle }}
                                        // className={classes.fieldLabel}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Mail Subject"
                                            value={formState.email_subject_prifix}
                                            type="text"
                                            name="email_subject_prifix"
                                            // placeholder="Mail Subject"
                                            // color="secondary"
                                            onChange={handleInputChange}
                                            variant="outlined"
                                        // InputProps={{ disableUnderline: true, className: classes.inputStyle }}
                                        // className={classes.fieldLabel}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <FormGroup style={{ margin: "16px 0" }}>
                                            <FormControlLabel
                                                control={<Checkbox checked={formState.secure_connection ? true : false} onChange={() => handleChangeCheckItem('secure_connection')} name="secure_connection" />}
                                                label="Use Secure Connection"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox checked={formState.use_authentication ? true : false} onChange={() => handleChangeCheckItem('use_authentication')} name="use_authentication" />}
                                                label="Use Authentication"
                                            />
                                        </FormGroup>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Login"
                                            value={formState.email_host_user}
                                            type="text"
                                            name="email_host_user"
                                            // placeholder="Login"
                                            // color="secondary"
                                            onChange={handleInputChange}
                                            variant="outlined"
                                        // InputProps={{ disableUnderline: true, className: classes.inputStyle }}
                                        // className={classes.fieldLabel}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Password"
                                            value={formState.email_host_password}
                                            type="password"
                                            name="email_host_password"
                                            // placeholder="Password"
                                            // color="secondary"
                                            onChange={handleInputChange}
                                            variant="outlined"
                                        // InputProps={{ disableUnderline: true, className: classes.inputStyle }}
                                        // className={classes.fieldLabel}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3} style={{ marginTop: 8 }}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <Button
                                            type={"button"}
                                            onClick={evt => setSendTestMailOpen(true)}
                                            variant="contained"
                                            color="primary"
                                            className={classes.btn}
                                            style={{ marginLeft: 0 }}
                                        >
                                            Send Test Email
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                    </React.Fragment>
                    )}
                    {partner && (<Grid container spacing={3} style={{ marginTop: 8 }}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Button className={`${classes.btn} ${classes.editThemeBtn}`} variant="outlined" onClick={editTheme} color="primary">Edit Theme</Button>
                        </Grid>
                    </Grid>
                    )}
                    <div className={classes.placeBtn}>
                        <Button onClick={() => {
                            history.push('/dashboard');
                        }} color="primary" className={classes.cancelBtn}>
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            className={classes.btn}
                            onClick={formValidationCheck}
                            disabled={loading}>
                            {loading ? <CircularProgress size={20} color="inherit" /> : 'Update Profile'}
                        </Button>
                    </div>
                </div>
                <SendTestEmailModal
                    open={sendTestMailOpen}
                    handleClose={evt => setSendTestMailOpen(false)}
                    handleSubmit={handleSendEmailSubmit}
                    loading={sendTestEmailLoading}
                />
            </main>
        </Layout>
    );
}

export default Profile;